import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { useTheme } from "styled-components";

import { Body } from "./styles";

interface IconTextProps {
  icon: IconProp;
  text: string;
}

export const IconText: React.FC<IconTextProps> = ({ icon, text }) => {
  const theme = useTheme();

  return (
    <IconTextContainer>
      <Circle $size={32} $backgroundColor="white">
        <FontAwesomeIcon icon={icon} fontSize="16px" color={theme.colors.redesign.o100} />
      </Circle>
      <Body>{text}</Body>
    </IconTextContainer>
  );
};

const IconTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Circle = styled.div<{ $size: number; $backgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;
